const STEP = 2.5;
const MAX_POSITION = 100;

function toPercents(position) {
  return `${position[0]}% ${position[1]}%`;
}

function calculateDuplicatedItemPosition(item) {
  const position = item
    .getAttribute('position')
    .split(' ')
    .map((value) => Math.min(MAX_POSITION, parseFloat(value) + STEP));

  return toPercents(position);
}

export default calculateDuplicatedItemPosition;
